import React from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ModalDialog } from '../../../components/ModalDialog';
import { HlasovaciMoznost, VysledekHlasovaniMoznost } from '../../../constants/enums'
import { formatDatetime } from '../../../utils/date';

const translateField = (field) => {
    const translations = {
        number: 'Číslo hlasování',
        time: 'Čas',
        result: 'Výsledek',
        valid: 'Platné',
        procedural: 'Procedurální',
        secret: 'Tajné',
        item: 'Předmět hlasování',
        minutes_url: 'Odkaz na protokol hlasování',
        option: 'Možnost',
        in_person: 'Prezenčně'
    };

    // Translate the field name if possible
    return translations[field] || field;
}

const formatValue = (field, value) => {
    // Format boolean values
    if (field === 'valid' || field === 'procedural' || field === 'secret' || field === 'in_person') {
        return value ? 'Ano' : 'Ne';
    }

    if (field === 'option') {
        switch(value) {
            case HlasovaciMoznost.YES:
                return 'Ano';
            case HlasovaciMoznost.NO:
                return 'Ne';
            case HlasovaciMoznost.ABSTAIN:
                return 'Zdržel/a se';
            case HlasovaciMoznost.NOT_VOTED:
                return 'Nehlasoval/a';
            case HlasovaciMoznost.ABSENT:
                return 'Nepřítomnost';
            case HlasovaciMoznost.SECRET:
                return 'Tajná';
            case HlasovaciMoznost.EXCUSED:
                return 'Omluven/a';
            default:
                return value;
        }
    }

    if (field === 'result') {
        switch(value) {
            case VysledekHlasovaniMoznost.ACCEPTED:
                return 'přijato';
            case VysledekHlasovaniMoznost.REJECTED:
                return 'nepřijato';
            default:
                return value;
        }
    }

    if (field === 'time') {
        return formatDatetime(value);
    }

    // Other values are kept as they are
    return value;
};

const changesTemplate = (changes) => {
    return (
        <ul>
            {changes.map((change, index) => (
                <li key={index}>
                    <strong>{translateField(change.field)}:</strong> "{formatValue(change.field, change.original)}" → "{formatValue(change.field, change.new)}"
                </li>
            ))}
        </ul>
    );
};

export function EditHistoryDialog({ isVisible, onHide, vote, memberVote }) {
    const data = vote ? vote : memberVote
    return (
        <ModalDialog
            visible={isVisible}
            header={
                vote
                    ? `Historie úprav hlasování č. ${vote.number}` 
                    : memberVote 
                        ? `Historie úprav hlasování člena ${memberVote.first_name} ${memberVote.last_name}`
                        : `Historie úprav`
            }
            onHide={onHide}
            style={{ width: 1180 }}
        >
            <DataTable
                value={data?.edit_history?.slice().reverse()}
                stripedRows
                paginator rows={10}
                rowsPerPageOptions={[10, 25, 50]}
                size='small'
                emptyMessage='Nenalezena žádná historie úprav'
            >
                <Column field='edit_date' header='Datum změny' bodyClassName='break-word' sortable />
                <Column field='edited_by' header='Autor změny' bodyClassName='break-word' sortable />
                <Column
                    header="Změny"
                    body={(rowData) => changesTemplate(rowData.changes)}
                    bodyClassName="break-word"
                />
            </DataTable>
        </ModalDialog>
    );
}
